module.exports = __webpack_public_path__ + "static/media/FrontEnd.fce60807.svg";